import { useState } from 'react';
import { urls } from '../services/apiService';

const usePreview = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState(null);

  const handlePreview = async (fieldName, date1, date2) => {
    const fetchData = async (date) => {
      const payload = { fieldName, date };
      try {
        const response = await fetch(urls.records, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
          },
          body: JSON.stringify(payload),
        });


        if (!response.ok) {
          throw new Error(`Failed to fetch data for ${date}`);
        }

        const result = await response.json();
        return result;
      } catch (error) {
        console.error(`Error fetching data for ${date}:`, error);
        throw error;
      }
    };

    setLoading(true); // Show loader
    try {
      // Fetch data for date1
      const result1 = await fetchData(date1);  

      // Check if date2 exists and fetch data
      let result2 = null;
      if (date2) {
        result2 = await fetchData(date2);
      }

      // Combine results into one object
      const combinedResult = result2
        ? { combined: [result1.records, result2.records] }
        : { combined: [result1.records] };

      // Set data in state and localStorage
      setData(combinedResult);
      localStorage.setItem('record', JSON.stringify(combinedResult));
      console.log('Combined Data:', combinedResult);

      // Open the report in a new tab
      window.open('/report', '_blank');
    } catch (error) {
      console.error('Error:', error);
    } finally {
      setLoading(false); // Hide loader
    }
  };

  return { handlePreview, loading, data };
};

export default usePreview;